<template>
    <div class="bg-primary-lightgrey py-4 px-2 mt-6 pt-0">
        <div class="flex items-center pb-2">
            <img src="../icons//booking-deliveries.svg" class="mr-2" />
            Shipments: Deliveries to {{ getReceieverWithPackages.length }} Receivers Shipment ID
        </div>
        <hr />
        <div class="mt-3"></div>
        <div class="mb-2" v-for="(packages, index) in shipping.shipmentReceiever" :key="index + 'reciever_package'">
            <div class="package_linner">
                <span>#{{ packages.reference }}</span>
                <span>{{ getName(index) }} ({{ getAddress(index) }})</span>
                <span @click="setActiveView(index)">
                   <button :class="activeView === index ? 'rotate-180' : ''">
                     <ArrowDownIcon color="black" />
                   </button>
                </span>
            </div>
            <section v-if="activeView === index">
                <div v-for="(packs, ind) in packages.packagees" :key="ind + 'reciever_package'"
                    class="bg-white flex flex-wrap px-2 py-3 rounded-lg mb-3 ">
                    <p class="w-full text-sm text-black">Package {{ ind + 1 }} of <span
                            class="opacity-50">{{ packages.packagees.length }}</span></p>
                    <div class="slice-option opacity-60">
                        <label class="label opacity-60">Shipment Category</label>
                        <input disabled @input="updateStoreOnChange($event, 'desc')" v-model="packs.shipmentCategory"
                            type="text" class="input-mini" />
                    </div>

                    <div class="slice-option opacity-60">
                        <label class="label">Shipment Description</label>
                        <input disabled @input="updateStoreOnChange($event, 'desc')" v-model="packs.description"
                            type="text" placeholder="Describe its content" class="input-mini" />
                    </div>

                    <div class="slice-option opacity-60">
                        <label class="label">Total estimated weight({{ packs.unitOfWeight }})</label>
                        <input disabled @input="updateStoreOnChange($event, 'weight')" type="number"
                            v-model="packs.estimatedWeight" placeholder="-- Enter --" class="input-mini" />
                    </div>

                    <div class="slice-option opacity-60">
                        <label class="label">Quantity</label>
                        <input disabled @input="updateStoreOnChange($event, 'quantity')" type="number"
                            v-model="packs.quantity" placeholder="-- Enter --" class="input-mini" />
                    </div>

                    <div class="slice-option opacity-60">
                        <label class="label">Total Value of Items (NGN)</label>
                        <input disabled @input="updateStoreOnChange($event, 'totalValue')" type="number"
                            v-model="packs.itemValue" placeholder="-- Enter --" class="input-mini" />
                    </div>

                    <div class="slice-option">
                        <div class="flex justify-between items-center mt-0">
                            <label class="label_handling opacity-60">Special handling?</label>
                        </div>
                        <el-select v-model="packs.specialHandling" multiple :disabled="packs.isSpecialHandling == 'no'"
                            placeholder="Special handling options">
                            <el-option v-for="option in handlingOptions" :key="option.value" :label="option.title"
                                :value="option.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import ArrowDownIcon from "@/components/UI/svgs/ArrowDownIcon.vue";
export default {
    name: 'packageList',
    props: {
        shipping: {
            type: Object,
            default: () => ({})
        }
    },
    components: {
        ArrowDownIcon
    },
    computed: {
        getReceieverWithPackages() {
            return this.$store.getters.getSavedNewRecieverPackage;
        }
    },
    data() {
        return {
            activeView: null,
            lightCategory: [
                "Parcel", "Document", "Electronic Device", "Food",
                "Medicines & Pharmaceuticals", "Beauty Products",
                "Fashion", "Books", "Others"
            ],
            handlingOptions: [
                { value: "fragile", title: "Fragile" },
                { value: "oversized", title: "Over-sized" },
                { value: "Confidential", title: "Confidential" },
                { value: "packagehandling", title: "⁠Package-handling" },
                { value: "inflammable", title: 'inflammable' },
                { value: "⁠radioactive", title: "Radioactive" },
            ],
        }
    },
    methods: {
        getAddress(index){
          return   this.getReceieverWithPackages[index]?.address?.name || "N/A"             
        },
        getName(index){
           return this.getReceieverWithPackages[index]?.name || this.getReceieverWithPackages[index]?.contactName || ''
        },
        setActiveView(index) {
            this.activeView != index ? (this.activeView = index) : (this.activeView = null)
        }
    },
    activated() {
       
    }
}
</script>

<style lang="scss" scoped>
.package_linner {
    @apply w-full flex items-center py-1 text-base px-2;

    span:nth-of-type(1) {
        @apply w-[25%] block;
    }

    ;

    span:nth-of-type(2) {
        @apply w-[calc(75%-70px)] block;
    }

    ;

    span:nth-of-type(3) {
        @apply w-[70px] flex cursor-pointer justify-end;
    }
}

.radio-label {
    @apply flex items-center mr-2;
}

.input-mini {
    @apply w-full py-2 px-2 border-[1px] border-primary-palegrey rounded-md bg-primary-lightblue resize-none;
}

.input-mini_textarea {
    @apply w-full py-2 px-2 border-[1px] border-primary-palegrey rounded-md bg-primary-lightblue resize-none h-24;
}

.slice-option {
    @apply mt-4 sm:mt-7 sm:w-[48%] lg:w-[32%] w-full mr-[2%] lg:mr-[1.333%];
}

.label_handling {
    @apply mt-1;
    white-space: nowrap;
}
</style>